import React from 'react';
import { Badge, Col, UncontrolledTooltip } from 'reactstrap';

export default function IconInfoCard({
	id,
	icon,
	text,
	color = '#32323d',
	badge,
}) {
	return (
		<React.Fragment>
			<Col sm="auto" className={`icone-card-item icone-exame`}>
				<span className="icone-card" style={{ color: color }}>
					<i id={`${id}`} style={{ fontSize: '1em' }} className={icon} />
					{badge && (
						<Badge color="info" pill className="icon-badge">
							{badge}
						</Badge>
					)}
				</span>
			</Col>
			<UncontrolledTooltip
				modifiers={{ preventOverflow: { boundariesElement: 'window' } }}
				autohide={false}
				delay={{ show: 100, hide: 5 }}
				placement="top"
				target={id}
			>
				{text}
			</UncontrolledTooltip>
		</React.Fragment>
	);
}



// WEBPACK FOOTER //
// ./src/containers/IconInfoCard/index.jsx